import React from 'react';
import { Box, Typography } from '@mui/material';
import ProdutoForm from '../components/produto/ProdutoForm';

const ProdutoNovo: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Novo Produto
      </Typography>
      <ProdutoForm />
    </Box>
  );
};

export default ProdutoNovo;
